import React from 'react';
import { Space, Modal as AntModal, Select, InputNumber, Row, Col, Typography, Input } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
const { Text } = Typography;

const ModalServicios = ({ isModalServicioOpen, setIsModalServicioOpen, agregarServicioAlCarrito, servTipo, handleSelectServicio,
    catalogoServicios, servNombre, setServNombre, servCosto, setServCosto, servPrecio, setServPrecio, servMargen, servGanancia }) => {
    return (
        <AntModal
            title={
                <Space>
                    <div style={{ background: '#dbeafe', padding: '8px', borderRadius: '8px', color: '#3b82f6' }}>
                        <ToolOutlined />
                    </div>
                    <span style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a' }}>Agregar Servicio</span>
                </Space>
            }
            open={isModalServicioOpen}
            onCancel={() => setIsModalServicioOpen(false)}
            onOk={agregarServicioAlCarrito}
            okText="Agregar al Carrito"
            cancelText="Cancelar"
            okButtonProps={{ style: { backgroundColor: '#3b82f6', height: '40px', fontWeight: 'bold' } }}
            centered
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>

                <div>
                    <Text strong>Tipo de Servicio *</Text>
                    <Select
                        style={{ width: '100%', marginTop: '4px' }}
                        size="large"
                        placeholder="Seleccione el tipo de servicio."
                        value={servTipo}
                        onChange={handleSelectServicio}
                        showSearch // Permite escribir para buscar más rápido
                        options={catalogoServicios.map(s => ({
                            value: s.nombre,
                            label: s.nombre,
                            precio_base: s.precio_base // Mandamos el precio base en la opción
                        }))}
                    />
                </div>

                <div>
                    <Text strong>Descripción del Servicio *</Text>
                    <Input
                        size="large"
                        placeholder="Ingrese la descripción del servicio."
                        value={servNombre}
                        onChange={e => setServNombre(e.target.value)}
                        style={{ marginTop: '4px' }}
                    />
                </div>

                <Row gutter={16}>
                    <Col span={12}>
                        <Text strong style={{ color: '#ef4444' }}>Costo del Servicio</Text>
                        <InputNumber
                            style={{ width: '100%', marginTop: '4px' }}
                            size="large"
                            controls={false}
                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            value={servCosto}
                            onChange={setServCosto}
                            min={0}
                        />
                    </Col>
                    <Col span={12}>
                        <Text strong style={{ color: '#10b981' }}>Precio de Venta del Servicio.</Text>
                        <InputNumber
                            style={{ width: '100%', marginTop: '4px' }}
                            size="large"
                            controls={false}
                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            value={servPrecio}
                            onChange={setServPrecio}
                            min={0}
                        />
                    </Col>
                </Row>

                <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Margen de Ganancia</Text>
                        <Text strong style={{ color: servMargen > 0 ? '#3b82f6' : '#64748b', fontSize: '16px' }}>
                            {servMargen}%
                        </Text>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Ganancia Real</Text>
                        <Text strong style={{ color: servGanancia > 0 ? '#10b981' : '#64748b', fontSize: '18px' }}>
                            ${servGanancia.toLocaleString('es-CO')}
                        </Text>
                    </div>
                </div>

            </div>
        </AntModal>
    )
}

export default ModalServicios;